<template>
  <div class="main">
    <a href="http://wpa.qq.com/msgrd?v=3&uin=3294192620&site=qq&menu=yes" target="blank">
      <el-popover style="margin-top:5px" :disabled="true" popper-class="popStyle">
        <el-button slot="reference">Q Q客服</el-button>
      </el-popover>
    </a>

    <el-popover style="margin-top:5px" placement="left" width="100" trigger="click">
      <img style="width: 150px;height: 150px" src="@/assets/images/weixinerweima.png" alt="">
      <el-button slot="reference">微信咨询</el-button>
    </el-popover>
    <el-popover
        style="margin-top:5px"
        placement="left"
        title="咨询电话"
        width="100"
        trigger="click"
        content="010-82965088"
    >
      <el-button slot="reference">服务热线</el-button>
    </el-popover>

    <!-- trigger="manual"完全手动控制 -->
    <el-popover
        ref="applyPopRef"
        v-model="visible"
        style="margin-top:5px;position: relative"
        placement="left"
        title="申请试点"
        width="550"
        trigger="manual"
        @close="handleDialogClose"
        @hide="clearText"
    >
      <div>
        <i @click="closeApplyPopup" class="el-icon-close"></i>
      </div>
      <div class="form-box">
        <p class="title-tabs">
          <i>*</i>申请单位
        </p>
        <el-input type="text" placeholder="请输入内容" v-model="title" maxlength="10"
                  show-word-limit></el-input>
        <p class="title-tabs">
          <i>*</i>中控数量
        </p>
        <el-radio v-model="radio" label="1">10个以内</el-radio>
        <el-radio v-model="radio" label="2">10-30个</el-radio>
        <el-radio v-model="radio" label="3">30-50个</el-radio>
        <el-radio v-model="radio" label="4">50个以上</el-radio>
        <p class="title-tabs">
          <i>*</i>中控情况描述
        </p>
      </div>
      <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="textarea"
          maxlength="100"
          show-word-limit
          resize="none"
      ></el-input>
      <p class="title-tabs">
        <i>*</i>联系方式
        <span>（联系人及联系方式）</span>
      </p>
      <el-input v-model="phoneNum"></el-input>
      <br/>
      <br/>
      <div style="display:flex;align-items: center">
        <button class="commit" @click="commitFeedback">确认提交</button>
      </div>

      <!-- reference绑定点击事件，实现点击悬浮栏按钮切换弹窗打开关闭 -->
      <div slot="reference">
        <el-button style="background-color: red;color: white" @click="toggleApplyPopup">申请试点</el-button>
      </div>
    </el-popover>

    <el-popover
        style="margin-top:5px"
        :disabled="true"
        placement="left"
        width="100"
        trigger="click"
    >
      <el-button slot="reference" @click="toTop">返回顶部</el-button>
    </el-popover>
  </div>
</template>

<script>
import {userFeedback} from "@/api/feedback";
import VueQr from "vue-qr";

export default {
  name: "Popover",
  components: {
    VueQr
  },
  methods: {
    // 悬浮栏按钮：切换打开/关闭
    toggleApplyPopup() {
      if (this.visible) {
        this.closeApplyPopup();
      } else {
        this.openApplyPopup();
      }
    },
    // 暴露给父组件调用：打开申请试点弹窗
    openApplyPopup() {
      this.clearText();
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.applyPopRef.show();
      })
    },
    // 暴露给父组件调用：关闭弹窗
    closeApplyPopup() {
      this.visible = false;
      this.$nextTick(() => {
        this.$refs.applyPopRef.hide();
      })
    },
    // dialog关闭回调（点遮罩、点右上角×都会走到这里）
    handleDialogClose() {
      this.$emit("popover-close");
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    clearText() {
      this.title = "";
      this.textarea = "";
      this.phoneNum = "";
    },
    commitFeedback() {
      const reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      const data = {
        title: this.title,
        description: this.textarea,
        contacts: this.phoneNum,
        isSolve: false,
        type: this.radio
      };
      if (!this.title) {
        this.$notify.error({title: "错误", message: "申请单位未填写"});
        return;
      }
      if (!this.textarea) {
        this.$notify.error({title: "错误", message: "中控情况描述未填写"});
        return;
      }
      if (!this.phoneNum) {
        this.$notify.error({title: "错误", message: "联系方式未填写"});
        return;
      }
      userFeedback(data).then(res => {
        if (res.code === 200) {
          this.$message({message: "您的反馈已经提交成功", type: "success"});
          // 提交成功关闭弹窗
          this.closeApplyPopup();
        } else {
          this.$notify.error({title: "错误", message: res.message});
        }
      });
    }
  },
  data() {
    return {
      visible: false,
      config: {
        value: "www.baidu.com"
      },
      title: "",
      radio: "1",
      textarea: "",
      phoneNum: ""
    };
  }
};
</script>

<style scoped>
.commit {
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #ff4a35;
  color: #fff;
  cursor: pointer;
}


.title-tabs {
  font-weight: 600;
  font-size: 14px;
  margin-top: 10px;
}

.title-tabs > i {
  color: red;
}

.wechatCode {
  width: 100%;
}

.popStyle {
  color: black;
}

.main {
  position: fixed;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  width: 66px;
  z-index: 999;
}

>>> .el-button {
  border: none;
  white-space: normal;
}

>>> .el-button:hover {
  background-color: red;
  color: #fff;
}

>>> .el-button > span {
  display: block;
  height: 36px;
  font-size: 18px;
  width: 36px;
}

.QQ {
  display: block;
  height: 52px;
  font-size: 18px;
  width: 52px;
  background-color: #fff;
}


/* 关闭按钮基础样式 */
.el-icon-close {
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 8px;
  cursor: pointer;
  background: #ededed;
  border-radius: 5px;
  /* 开启过渡动画：背景、颜色、旋转、缩放 */
  transition: background 0.22s ease, color 0.22s ease, transform 0.22s ease;
}

/* hover：背景变色 + 轻微放大 + 旋转小效果 */
.el-icon-close:hover {
  background: #ff4a35;
  color: white;
  transform: rotate(90deg);
}

</style>
